<template>
  <div class="machinePage">


    <v-timeline>
    <v-timeline-item>timeline item</v-timeline-item>
    <v-timeline-item class="text-right">
      timeline item
    </v-timeline-item>
    <v-timeline-item>timeline item</v-timeline-item>
  </v-timeline>
    
  </div>
</template>

<script>
//import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
//import MachineList from "@/components/machine/MachineList.vue";
//import MachineDettails from "@/components/machine/MachineDettails.vue";

import { mapState } from "vuex"; //, mapGetters
import machineService from "../services/machine";

export default {
  name: "MachineView",
  data() {
    return {
      //selectedMachine: null,
      //machineListFiltered:null,
      filter: {
        customerid: null,
        ownerid: null,
        site: null
      },
      showFilters : false,
      ownerList : [],
      
      

    };
  },
  mounted() {
    //this.$store.dispatch("machineModule/loadMachines");

    // query string search
    if(this.$route.query.customerid) {
      this.filter.customerid = this.$route.query.customerid;
      this.showFilters = true;
    }
    if(this.$route.query.ownerid) {
      this.filter.ownerid = this.$route.query.ownerid;
      this.showFilters = true;
    }
    // Funziona questo?
    this.filter.ownerid = this.$store.getters["appModule/authInfo"].authInfo.user.id;
    //this.machineListFiltered = machineList
  },
  computed: {
    siteListFormatted(){
      let data = this.siteList.map( elem => {
        return {
          code: elem._id.toString(),
          label: elem.name + ' (' + elem.address + ',' + elem.city + ')', //elem.machineId
        }
      })
      //console.log("Oggetto:" + JSON.stringify(data));
      return data;
    },
    /*...mapGetters("machineModule", {
      machineList: function(getters) {
        //return state.machineList;
        return getters.machineListFiltered;
      }
    }),**/
    ...mapState("machineModule", {
      machineDetail: function(state) {
        return state.machineDetail;
      },
      machineListFiltered: function(state) {
        if(!this.filter.site && !this.filter.ownerid) {
          return state.machineList;
        }
        //debugger;
        return state.machineList.filter(m=>  {
          return (!this.filter.site || m.site == this.filter.site) &&
                 (!this.filter.ownerid || m.owner == this.filter.ownerid) 
        })
        
      }
    }),
    ...mapState("customerModule", {
      customerList: function(state) {
        return state.customerList;
      }
    }),
    ...mapState("userModule", {
      userList: function(state) {
        return state.userList;
      }
    }),
    ...mapState("siteModule", {
      siteList: function(state) {
        return state.siteList;
      }
    }),
    inModifyMode() {
      return !!(this.machineDetail && this.machineDetail._id)
    },
    authInfo() {
      return this.$store.getters["appModule/authInfo"];
    }
  },
  methods: {
    async onOkMachine() {
      if(!this.machineDetail)
        return;
      let reqAnwser ;
      try{
        if(this.machineDetail._id) {
          reqAnwser = await machineService.updateMachine(this.machineDetail)
        } else {
          reqAnwser = await machineService.createMachine(this.machineDetail)
        }
        this.$store.dispatch("appModule/addInfoMessage", "Inserimento/modifica completata" )
      }catch(err) {
        this.$store.dispatch("appModule/addErrorMessage", "Errore nella creazione o nella modifica:" + JSON.stringify(err) + " ||| Answer:"+JSON.stringify(reqAnwser), { root: true } )
      }
      
      this.$store.dispatch("machineModule/loadMachines")
    },
    async onDeleteMachine(machine) {
      if(!this.machineDetail || !this.machineDetail._id || this.machineDetail._id !== machine._id)
        return;
      if(!confirm("Confermi di voler cancellare questa machine")) {
        return;
      }
      await machineService.deleteMachine(this.machineDetail._id)
      this.$store.dispatch("machineModule/loadMachines" )
    },
    newMachine(){
        this.onChangeMachine()
    },
    onAddCustomData() {
      if(!this.machineDetail)
        return;
      this.machineDetail.customData = [...this.machineDetail.customData, { name:'', value: ''}];
    },
    onRemoveCustomData(index) {
      if(!this.machineDetail)
        return;
      this.machineDetail.customData = this.machineDetail.customData.splice(index, 1)
    },
    closeDetail() {
      this.$refs['machine-modal'].hide()
    },
    onChangeMachine(machine) {
      this.$store.dispatch("machineModule/loadMachineDetails", machine )
      this.$refs['machine-modal'].show()
    },
    onChangeSiteFilter(siteId) {
      //console.log("Place changed:" + siteId)
      this.filter.site = siteId;
    }
  },
  components: {
    //MachineList,
    //MachineDettails,
    //vSelect
  }
};
</script>

